package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_04_18_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes leave early in the morning. The lady Drow have a head start, but they can’t scry the shard of Concar’s location nor do they have an expert tracker (Elrovir). Caper thinks she could turn rivals into friends.")
    }
}
